
import { Component } from 'vue-property-decorator'
import { Goods, GoodsStatus } from '@/interfaces/goods'
import { SnackType } from '@/interfaces/snack'
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime'
import { showErrors, showNotification } from '@/utils/snack'
import { findGood, deleteGood } from './gql'
import { statusCodes, statusOptions, GoodsStatusText } from '@/helpers/goods'
import { TypedGqlError } from '@/interfaces/error'
import AuthFilter from '@/mixins/auth-filter'
import { mixins } from 'vue-class-component'

@Component({})
export default class GoodsDialog extends mixins(AuthFilter) {
  targetgoods: Goods | null = null

  deleteDialog = {
    show: false,
    title: '删除商品品类',
    text: ''
  }

  statusOptions = statusOptions()
  statusCodes = statusCodes()
  GoodsStatusText = GoodsStatusText
  GoodsStatus = GoodsStatus

  utcDateTimeToLocal = utcDateTimeToLocal
  utcDateTimeToDate = utcDateTimeToDate

  isDefaultCover (item: Goods) {
    return item.thumb === process.env.VUE_APP_DOMAIN + '/book_covers/hd_book_default_cover.png'
  }

  usingStatus (status: string) {
    return {
      'u-tag-blue': status === this.GoodsStatus.ON_SHELVES,
      'u-tag-red': status === this.GoodsStatus.OFF_SHELVES
    }
  }

  // 添加goods
  addGoods () {
    this.$router.push({
      name: 'EditGoods',
      params: {
        type: 'new'
      }
    })
  }

  // 编辑goods
  editGoods (item: any, type: string) {
    this.$router.push({
      name: 'EditGoods',
      params: {
        type: type,
        id: item.id,
        name: item.title
      }
    })
  }

  // 删除弹框显示
  async deleteGoods (goods: Goods) {
    this.targetgoods = goods
    this.deleteDialog.text = `是否确定删除商品品类 “${goods.title}” ?`
    this.deleteDialog.show = true
  }

  // 删除request
  async deleteGoodsRequest () {
    if (!this.targetgoods) {
      return
    }
    const { id } = this.targetgoods
    this.deleteDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteGood,
        variables: {
          goodId: id
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功!',
          type: SnackType.Success
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async getGoodsById (goodId: number) {
    try {
      const result = await this.$apollo.query({
        query: findGood,
        variables: {
          goodId
        }
      })
      return result.data.findGood
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
